export default __webpack_public_path__ + "static/media/blobs1.98071743.png";